module.exports = __webpack_public_path__ + "img/mi-online-services.6fddfd67.svg";